export const createBreakoutRoom = (roomId) => ({
  type: "CREATE_BREAKOUT_ROOM",
  payload: { roomId },
});

export const removeBreakoutRoom = (roomId) => ({
  type: "REMOVE_BREAKOUT_ROOM",
  payload: { roomId },
});

export const addUserToPeerMap = (user) => ({
  type: "ADD_USER_TO_PEER_MAP",
  payload: { user },
});

export const removeUserFromPeerMap = (user) => ({
  type: "REMOVE_USER_FROM_PEER_MAP",
  payload: { user },
});

export const updateUserFromPeerMap = (user) => ({
  type: "UPDATE_USER_FROM_PEER_MAP",
  payload: { user },
});

export const setUsers = (users) => ({
  type: "SET_USERS",
  payload: { users },
});

export const next = (nextval) => ({
  type: "NEXT",
  payload: nextval,
});